{
  "addons.addonList": "Add-on list",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Create and retrieve your API key from this link",
  "addons.ambientWeatherDescription": "Ambient Weather stations (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API key",
  "addons.applicationKey": "Application key",
  "addons.connect": "Connect",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "V2 API Key",
  "addons.davisDescription": "Davis weather stations (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Retrieve your V2 API keys from this link",
  "addons.disconnect": "Disconnect",
  "addons.ecowittCreateAndRetrieveKeys": "Create and retrieve both an API key and an application key from this link",
  "addons.ecowittDescription": "Ecowitt provides professional wifi weather station, wireless indoor outdoor thermometers, humidity monitors, high precision rain gauges, air quality monitors and more.",
  "addons.helpLink": "How to connect {provider}",
  "addons.myAcuriteAccountOnHold": "Your account has been placed on hold. Please enter your password to reconnect your account",
  "addons.myAcuriteDescription": "AcuRite is the #1 weather station brand in North America. As a leader in time, temperature, and weather technology, AcuRite provides you with detailed information about your indoor and outdoor environment so you can plan your day with confidence.",
  "addons.myAcuriteEnterCredentials": "Enter your My AcuRite credentials in order to link your My AcuRite account with SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Use your Netatmo Thermostat to change your home's temperature, from your bed or from the other side of the world.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Your personal weather station at home",
  "addons.or": "or",
  "addons.providerAccountDisconnected": "The connection to your weather service has expired. Please reconnect to resume data updates.",
  "addons.reconnect": "Reconnect",
  "addons.weatherflowCreateToken": "Create and retrieve your token from this link",
  "addons.weatherflowTempestDescription": "Tempest Weather System with Built-in Wind Meter, Rain Gauge",
  "addons.wundergroundApiKey": "API key",
  "addons.wundergroundDescription": "Weather Underground is a global community of people connecting data from environmental sensors like weather stations and air quality monitors so we can provide the rich, hyperlocal data you need to power your passions",
  "addons.wundergroundRetrieveApiKey": "Retrieve your API key from this link",
  "addons.wundergroundRetrieveStationId": "Retrieve your station ID from this link",
  "addons.wundergroundStationId": "Station ID",
  "airQuality.airQuality": "Air quality",
  "airQuality.airQualityIndex": "Air quality index",
  "airQuality.aqiForecast": "AQI Forecast",
  "airQuality.co": "Carbon monoxide",
  "airQuality.dailyForecast": "Daily forecast",
  "airQuality.details": "Details",
  "airQuality.dominantPollutant": "Dominant pollutant",
  "airQuality.good": "Good",
  "airQuality.goodDescription": "Air quality is considered satisfactory, and air pollution poses little or no risk",
  "airQuality.hazardous": "Hazardous",
  "airQuality.hazardousDescription": "Health alert: anyone may experience more serious health effects",
  "airQuality.indoorAirQuality": "Indoor air quality",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Moderate",
  "airQuality.moderateDescription": "Air quality is acceptable; however, for some pollutants there may be a moderate health concern for a very small number of people who are unusually sensitive to air pollution.",
  "airQuality.no2": "Nitrogen dioxide",
  "airQuality.o3": "Ozone",
  "airQuality.pm10": "Particles with a diameter of 10 μm or less",
  "airQuality.pm25": "Particles with a diameter of 2.5 μm or less",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Unhealthy for sensitive people",
  "airQuality.sensitiveUnhealthyDescription": "Members of sensitive groups may experience health effects. The general public is not likely to be affected.",
  "airQuality.so2": "Sulfur dioxide",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Unhealthy",
  "airQuality.unhealthyDescription": "Everyone may begin to experience health effects; members of sensitive groups may experience more serious health effects",
  "airQuality.veryUnhealthy": "Very unhealthy",
  "airQuality.veryUnhealthyDezscription": "Health warnings of emergency conditions. The entire population is more likely to be affected.",
  "alerts.addAlert": "Add alert",
  "alerts.addCondition": "Add condition",
  "alerts.alertAdded": "Alert successfully added",
  "alerts.alertAuthorizationNotice": "Alerts work only if you authorize SmartMixin to display notifications",
  "alerts.alertDeleted": "Alert successfully deleted",
  "alerts.alertEdited": "Alert successfully modified",
  "alerts.alertName": "Alert name",
  "alerts.alertWhen": "I want to be alerted when:",
  "alerts.aqiGreaterThan": "AQI greater than",
  "alerts.aqiGreaterThanThreshold": "AQI greater than {value}{unit} threshold",
  "alerts.aqiLessThan": "AQI less than",
  "alerts.aqiLessThanThreshold": "AQI less than {value}{unit} threshold",
  "alerts.atLeastOneCondition": "You need to add at least one condition",
  "alerts.co2GreaterThan": "CO2 greater than",
  "alerts.co2GreaterThanThreshold": "CO2 greater than {value}{unit} threshold",
  "alerts.co2LessThan": "CO2 less than",
  "alerts.co2LessThanThreshold": "CO2 less than {value}{unit} threshold",
  "alerts.conditions": "Conditions",
  "alerts.createAlert": "Create alert",
  "alerts.dailyPrecipitationGreaterThan": "Daily precipitation greater than",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Daily precipitation greater than {value}{unit} threshold",
  "alerts.deleteAlert": "Delete alert",
  "alerts.editAlert": "Edit alert",
  "alerts.editCondition": "Edit condition",
  "alerts.gustSpeedGreaterThan": "Gust speed greater than",
  "alerts.gustSpeedGreaterThanThreshold": "Gust speed greater than {value}{unit} threshold",
  "alerts.gustSpeedLessThan": "Gust speed less than",
  "alerts.gustSpeedLessThanThreshold": "Gust speed less than {value}{unit} threshold",
  "alerts.heatIndexGreaterThan": "Heat index greater than",
  "alerts.heatIndexGreaterThanThreshold": "Heat index greater than {value}{unit} threshold",
  "alerts.heatIndexLessThan": "Heat index less than",
  "alerts.heatIndexLessThanThreshold": "Heat index less than {value}{unit} threshold",
  "alerts.humidexGreaterThan": "Humidex greater than",
  "alerts.humidexGreaterThanThreshold": "Humidex greater than {value}{unit} threshold",
  "alerts.humidexLessThan": "Humidex less than",
  "alerts.humidexLessThanThreshold": "Humidex less than {value}{unit} threshold",
  "alerts.humidityGreaterThan": "Humidity greater than",
  "alerts.humidityGreaterThanThreshold": "Humidity greater than {value}{unit} threshold",
  "alerts.humidityLessThan": "Humidity less than",
  "alerts.humidityLessThanThreshold": "Humidity less than {value}{unit} threshold",
  "alerts.inProgress": "In Progress",
  "alerts.myAlerts": "My alerts",
  "alerts.noConfiguredAlert": "You don't have any alerts configured yet, start adding one",
  "alerts.noiseGreaterThan": "Noise greater than",
  "alerts.noiseGreaterThanThreshold": "Noise greater than {value}{unit} threshold",
  "alerts.noiseLessThan": "Noise less than",
  "alerts.noiseLessThanThreshold": "Noise less than {value}{unit} threshold",
  "alerts.noteOnConditions": "Note that the alert is triggered when all of the below conditions are verified",
  "alerts.pm10GreaterThan": "PM 10 greater than",
  "alerts.pm10GreaterThanThreshold": "PM 10 greater than {value}{unit} threshold",
  "alerts.pm10LessThan": "PM 10 less than",
  "alerts.pm10LessThanThreshold": "PM 10 less than {value}{unit} threshold",
  "alerts.pm1GreaterThan": "PM 1 greater than",
  "alerts.pm1GreaterThanThreshold": "PM 1 greater than {value}{unit} threshold",
  "alerts.pm1LessThan": "PM 1 less than",
  "alerts.pm1LessThanThreshold": "PM 1 less than {value}{unit} threshold",
  "alerts.pm2p5GreaterThan": "PM 2.5 greater than",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 greater than {value}{unit} threshold",
  "alerts.pm2p5LessThan": "PM 2.5 less than",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 less than {value}{unit} threshold",
  "alerts.postStormSummary": "Post-storm summary",
  "alerts.postStormSynopsisHelper": "You'll get a summary notification after each rain storm ends.",
  "alerts.postStormSynopsisSoleCondition": "A post-storm summary can't be combined with other conditions.",
  "alerts.precipitationGreaterThan": "Hourly precipitation greater than",
  "alerts.precipitationGreaterThanThreshold": "Hourly precipitation greater than {value}{unit} threshold",
  "alerts.pressureGreaterThan": "Pressure greater than",
  "alerts.pressureGreaterThanThreshold": "Pressure greater than {value}{unit} threshold",
  "alerts.pressureLessThan": "Pressure less than",
  "alerts.pressureLessThanThreshold": "Pressure less than {value}{unit} threshold",
  "alerts.rainRateGreaterThan": "Rain rate greater than",
  "alerts.rainRateGreaterThanThreshold": "Rain rate greater than {value}{unit} threshold",
  "alerts.solarRadiationGreaterThan": "Solar radiation greater than",
  "alerts.solarRadiationGreaterThanThreshold": "Solar radiation greater than {value}{unit} threshold",
  "alerts.solarRadiationLessThan": "Solar radiation less than",
  "alerts.solarRadiationLessThanThreshold": "Solar radiation less than {value}{unit} threshold",
  "alerts.temperatureGreaterThan": "Temperature greater than",
  "alerts.temperatureGreaterThanThreshold": "Temperature greater than {value}{unit} threshold",
  "alerts.temperatureLessThan": "Temperature less than",
  "alerts.temperatureLessThanThreshold": "Temperature less than {value}{unit} threshold",
  "alerts.thswGreaterThan": "THSW greater than",
  "alerts.thswGreaterThanThreshold": "THSW greater than {value}{unit} threshold",
  "alerts.thswLessThan": "THSW less than",
  "alerts.thswLessThanThreshold": "THSW less than {value}{unit} threshold",
  "alerts.thwGreaterThan": "THW greater than",
  "alerts.thwGreaterThanThreshold": "THW greater than {value}{unit} threshold",
  "alerts.thwLessThan": "THW less than",
  "alerts.thwLessThanThreshold": "THW less than {value}{unit} threshold",
  "alerts.uvGreaterThan": "UV index greater than",
  "alerts.uvGreaterThanThreshold": "UV index greater than {value}{unit} threshold",
  "alerts.uvLessThan": "UV index less than",
  "alerts.uvLessThanThreshold": "UV index less than {value}{unit} threshold",
  "alerts.visibilityGreaterThanThreshold": "Visibility greater than {value}{unit} threshold",
  "alerts.visibilityLessThanThreshold": "Visibility less than {value}{unit} threshold",
  "alerts.visiblityGreaterThan": "Visibility greater than",
  "alerts.visiblityLessThan": "Visibility less than",
  "alerts.whichMeasure": "Which measure would you like to be alerted for?",
  "alerts.whichModule": "Which module would you like to be alerted for?",
  "alerts.windChillGreaterThan": "Wind chill greater than",
  "alerts.windChillGreaterThanThreshold": "Wind chill greater than {value}{unit} threshold",
  "alerts.windChillLessThan": "Wind chill less than",
  "alerts.windChillLessThanThreshold": "Wind chill less than {value}{unit} threshold",
  "alerts.windSpeedGreaterThan": "Wind speed greater than",
  "alerts.windSpeedGreaterThanThreshold": "Wind speed greater than {value}{unit} threshold",
  "alerts.windSpeedLessThan": "Wind speed less than",
  "alerts.windSpeedLessThanThreshold": "Wind speed less than {value}{unit} threshold",
  "astral.astronomicalSunPhase": "Astronomical {sunPhase}",
  "astral.civilSunPhase": "Civil {sunPhase}",
  "astral.dawn": "Dawn",
  "astral.dusk": "Dusk",
  "astral.firstQuarter": "First quarter",
  "astral.fullMoon": "Full moon",
  "astral.lastQuarter": "Last quarter",
  "astral.moon": "Moon",
  "astral.moonPhases": "Moon phases",
  "astral.moonrise": "Moonrise",
  "astral.moonset": "Moonset",
  "astral.nauticalSunPhase": "Nautical {sunPhase}",
  "astral.newMoon": "New moon",
  "astral.noon": "Noon",
  "astral.remainingDaylight": "Remaining daylight",
  "astral.sunrise": "Sunrise",
  "astral.sunriseAndSunset": "Sunrise and sunset",
  "astral.sunriseAt": "Sunrise at {time}",
  "astral.sunset": "Sunset",
  "astral.sunsetAt": "Sunset at {time}",
  "astral.totalDaylight": "Total daylight",
  "astral.waningCrescent": "Waning crescent",
  "astral.waningGibbous": "Waning gibbous",
  "astral.waxingCrescent": "Waxing crescent",
  "astral.waxingGibbous": "Waxing gibbous",
  "auth.alreadyHaveAccount": "Already have an account?",
  "auth.authContainerTagline": "Your personal weather dashboard. Connect your stations and get real-time data at your fingertips.",
  "auth.backToLogin": "Back to login",
  "auth.catchPhrase": "The Weather Intelligence Platform",
  "auth.checkYourEmail": "Check your email",
  "auth.continueWithApple": "Continue with Apple",
  "auth.continueWithFacebook": "Continue with Facebook",
  "auth.continueWithGoogle": "Continue with Google",
  "auth.email": "Email address",
  "auth.emailRequiredLoginFacebook": "Email permission is required.",
  "auth.emailVerification": "Email verification",
  "auth.emailVerificationFailure": "A problem occurred with your email verification.",
  "auth.emailVerificationSuccess": "Your email has been successfully verified.",
  "auth.firstName": "First name",
  "auth.forgotPassword": "Forgot your password?",
  "auth.forgotPasswordSubtitle": "Enter your email and we'll send you a link to reset your password.",
  "auth.lastName": "Last name",
  "auth.login": "Login",
  "auth.loginSubtitle": "Welcome back! Please enter your details.",
  "auth.loginToSmartMixinDescription": "Sign in to SmartMixin to access your weather stations, view analytics, and manage your personal weather dashboard.",
  "auth.logout": "Logout",
  "auth.logoutConfirmation": "Are you sure you want to logout?",
  "auth.noAccountYet": "Don't have an account?",
  "auth.or": "or",
  "auth.password": "Password",
  "auth.passwordAgain": "Password again",
  "auth.passwordReset": "Password reset",
  "auth.passwordResetSuccess": "Your password has been successfully updated.",
  "auth.register": "Create account",
  "auth.registerDescription": "Create a free SmartMixin account to connect your weather stations, track weather data, and access powerful analytics tools.",
  "auth.registerSubtitle": "Create your account to get started.",
  "auth.registerSuccess": "You've successfully registered! We've just sent you a verification link at {emailAddress} with further instructions.",
  "auth.restorePassword": "Restore Password",
  "auth.restorePasswordSuccess": "We've just sent you a password reset link at {emailAddress} with further instructions.",
  "auth.sendReset": "Send reset instructions",
  "auth.socialAccount": "or use your account",
  "auth.welcome": "Welcome to SmartMixin",
  "auth.welcomeBack": "Welcome back!",
  "calendar.april": "April",
  "calendar.august": "August",
  "calendar.dateFormat": "Date format",
  "calendar.day": "Day",
  "calendar.december": "December",
  "calendar.end": "End",
  "calendar.february": "February",
  "calendar.hours": "Hours",
  "calendar.hoursShort": "hrs",
  "calendar.january": "January",
  "calendar.july": "July",
  "calendar.june": "June",
  "calendar.last24Hours": "Last 24 hours",
  "calendar.last30Days": "Last 30 days",
  "calendar.last7Days": "Last 7 days",
  "calendar.march": "March",
  "calendar.max": "Max",
  "calendar.may": "May",
  "calendar.month": "Month",
  "calendar.months": "months",
  "calendar.november": "November",
  "calendar.october": "October",
  "calendar.oneDay": "1-day",
  "calendar.oneHour": "1-hour",
  "calendar.oneMonth": "1-month",
  "calendar.oneWeek": "1-week",
  "calendar.previous24Hours": "Previous 24 hours",
  "calendar.previous30Days": "Previous 30 days",
  "calendar.previous7Days": "Previous 7 days",
  "calendar.previousDay": "Previous day",
  "calendar.previousMonth": "Previous month",
  "calendar.previousWeek": "Previous week",
  "calendar.previousYear": "Previous year",
  "calendar.sameDayLastYear": "Same day last year",
  "calendar.sameMonthLastYear": "Same month last year",
  "calendar.selectADate": "Select a date",
  "calendar.selectAggregation": "Select displayed value",
  "calendar.selectAMonth": "Select a month",
  "calendar.selectAYear": "Select a year",
  "calendar.selectGranularity": "Select a granularity",
  "calendar.selectTimescale": "Select a time scale",
  "calendar.september": "September",
  "calendar.sixHours": "6-hour",
  "calendar.start": "Start",
  "calendar.thirtyMinutes": "30-min",
  "calendar.threeHours": "3-hour",
  "calendar.use24HourFormat": "Use 24-hour format",
  "calendar.week": "Week",
  "calendar.year": "Year",
  "calendar.yesterday": "Yesterday",
  "common.accountDeleted": "Your account has been successfully deleted.",
  "common.accountOnHold": "Your account connection has expired. Please reconnect to resume data updates.",
  "common.add": "Add",
  "common.addAStation": "Add a station",
  "common.addToFavorites": "Add to favorites",
  "common.addYourOwnStation": "Add your own station",
  "common.alreadyPremium": "You already have a premium account!",
  "common.alsoAvailableOn": "Also available on:",
  "common.altitude": "Altitude",
  "common.analysis": "Analysis",
  "common.aroundMe": "Around me",
  "common.articleCount": "{count, plural, one {# article} other {# articles}}",
  "common.articleNotFound": "Article Not Found",
  "common.articleNotFoundDescription": "The article you're looking for doesn't exist.",
  "common.average": "Average",
  "common.averageOverThePeriod": "Average over the period",
  "common.away": "Away",
  "common.back": "Back",
  "common.backToHelpCenter": "Back to Help Center",
  "common.backToHome": "Back to Home",
  "common.bad": "Bad",
  "common.batteryLevel": "Battery level",
  "common.bestValue": "Best Value",
  "common.billingDetailsAndroid": "For free trial offer, you will not be charged if you cancel 24 hours before the free introductory period expires. When the trial is over, you can cancel SmartMixin subscription anytime through your Google Play account settings, or it will be automatically renewed. This must be done 24 hours before the end of the subscription period to avoid being charged another fee shown in the button above. Subscription payments will be charged to your Google Play account at confirmation of your purchase and upon commencement of each renewal term.",
  "common.billingDetailsIos": "For free trial offer, you will not be charged if you cancel 24 hours before the free introductory period expires. When the trial is over, you can cancel SmartMixin subscription anytime through your App Store account settings, or it will be automatically renewed. This must be done 24 hours before the end of the subscription period to avoid being charged another fee shown in the button above. Subscription payments will be charged to your App Store account at confirmation of your purchase and upon commencement of each renewal term.",
  "common.boilerOn": "Boiler ON",
  "common.browseByCategory": "Browse by Category",
  "common.calendarView": "Calendar view",
  "common.cancel": "Cancel",
  "common.cannotBeEmpty": "This field cannot be empty.",
  "common.cardDetails": "Card details",
  "common.categoryNotFound": "Category not found",
  "common.categoryNotFoundDescription": "This category doesn't exist or has no articles.",
  "common.charts": "Charts",
  "common.chartView": "Chart view",
  "common.clearRecentLocations": "Clear all",
  "common.close": "Close",
  "common.comparison": "Comparison",
  "common.contactMe": "Contact me",
  "common.currentDay": "Current day",
  "common.currentLocation": "Current location",
  "common.currentObservations": "Current observations",
  "common.currentRainEvent": "Current rain event",
  "common.currentRate": "Current rate",
  "common.currentWeatherConditions": "Current conditions",
  "common.customizeComparisonMetrics": "Customize metrics",
  "common.customizeComparisonMetricsDescription": "Drag items to reorder your comparison metrics. Tap the eye icon to show or hide metrics.",
  "common.customizeDashboard": "Customize",
  "common.customizeDashboardDescription": "Drag items to reorder your dashboard. Tap the eye icon to show or hide sections.",
  "common.customizedStationName": "Customized station name",
  "common.dailyForecast": "Daily forecast",
  "common.dashboard": "Dashboard",
  "common.default": "Default",
  "common.defaultForecastModelChip": "Default · {name}",
  "common.delete": "Delete",
  "common.deleteAccount": "Delete your account",
  "common.deleteAccountConfirmation": "Are you sure you want to delete your account? This action is irreversible.",
  "common.deleteAccountDescription": "This action deletes your account and all your information. There is no going back.",
  "common.details": "Details",
  "common.edit": "Edit",
  "common.editor": "Editor",
  "common.endTime": "End time",
  "common.exitFullscreen": "Exit fullscreen",
  "common.exploreWeatherMap": "Explore Weather Map",
  "common.favoriteLocations": "Favorites",
  "common.favoriteLocationsEmpty": "You can add up to 5 favorite locations.",
  "common.favoriteStations": "Favorite stations",
  "common.feedbackHelpsImprove": "Your input helps us improve our help articles.",
  "common.feedbackReasonNotAnswer": "It doesn't answer my question",
  "common.feedbackReasonOutdated": "The information is outdated",
  "common.feedbackReasonUnclear": "The instructions are unclear",
  "common.feedbackWhatWentWrong": "What was the problem?",
  "common.filterStationDescription": "Do not display stations with unreliable measures",
  "common.filterStations": "Filter stations",
  "common.filterStationSourceDescription": "Select station providers that you want to display on the map",
  "common.findStationsNearYou": "Find Stations Near You",
  "common.firmwareVersion": "Firmware version",
  "common.forecast": "Forecast",
  "common.forecastComparisonDescription": "Easily compare forecast model outputs from several sources",
  "common.forecastModelComparison": "Forecast model comparison",
  "common.forecastModelCoverage": "Coverage",
  "common.forecastModelDescription": "Description",
  "common.forecastModelDescription_AROME": "Météo France's high-resolution convection-allowing model over Western Europe at 1.3 km resolution. Best-in-class for short-term forecasts in France; refreshed every three hours.",
  "common.forecastModelDescription_ARPEGE_EU": "Météo France's European nest of the ARPEGE model at 10 km resolution. Mid-range forecasts over Europe, refreshed four times daily.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Météo France's global numerical weather model at 25 km resolution, running to about 4 days. Refreshed four times daily.",
  "common.forecastModelDescription_DMI_DINI": "DMI's HARMONIE DINI: a convection-allowing model over northwest Europe — Denmark, the Benelux, Ireland, the UK and Scandinavia — at 2 km resolution out to 60 hours, refreshed eight times daily. Contains modified DMI open data (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Environment Canada's Global Deterministic Prediction System: a worldwide medium-range model at 15 km resolution running out to 10 days, updated twice daily.",
  "common.forecastModelDescription_EC_HRDPS": "Environment Canada's High Resolution Deterministic Prediction System: a convection-allowing model over Canada and the northern United States at 2.5 km resolution out to 48 hours, refreshed four times daily.",
  "common.forecastModelDescription_EC_RDPS": "Environment Canada's Regional Deterministic Prediction System: a mid-range model over North America at 10 km resolution, refreshed four times daily.",
  "common.forecastModelDescription_ECMWF_HRES": "The European Centre for Medium-Range Weather Forecasts' flagship high-resolution model (IFS), widely regarded as the world's leading global forecast system. Covers the entire planet at 25 km resolution out to 15 days, updated four times daily. Contains modified ECMWF open data (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "NOAA's flagship medium-range global model. Covers the entire planet at 25 km resolution out to 16 days, updated four times per day.",
  "common.forecastModelDescription_HRRR_CONUS": "NOAA's High-Resolution Rapid Refresh: a convection-allowing model over the continental United States at 3 km resolution, refreshed every hour. Best suited for very short-term forecasts of thunderstorms and severe weather.",
  "common.forecastModelDescription_ICON": "DWD's global ICON model at 13 km resolution covering the entire planet out to 7.5 days, refreshed four times daily. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ItaliaMeteo's ICON-2I, run jointly with ARPAE: a convection-allowing model over Italy at 2.2 km resolution out to 72 hours, refreshed twice daily. Contains ItaliaMeteo open data (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "MeteoSwiss's ICON-CH1-EPS control run: a convection-allowing model over the Alps at 1 km resolution out to 33 hours, refreshed every three hours.",
  "common.forecastModelDescription_ICON_CH2": "MeteoSwiss's ICON-CH2-EPS control run: a convection-allowing model over the Alps — Switzerland and the surrounding Alpine region — at 2.1 km resolution out to 120 hours, refreshed four times daily.",
  "common.forecastModelDescription_ICON_DE": "DWD's high-resolution convection-allowing model over Germany and surrounding countries at 2.2 km resolution. Short-term forecasts refreshed twice daily. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "DWD's European nest of the ICON model at 7 km resolution covering Europe and the North Atlantic. Mid-range forecasts refreshed four times daily. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "The Norwegian Meteorological Institute's open weather forecast service, blending high-resolution Nordic models with ECMWF data to provide worldwide forecasts up to 10 days ahead.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME nest over the French Antilles (Guadeloupe, Martinique) at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME nest over French Guiana at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME nest over New Caledonia at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME nest over French Polynesia at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME nest over Réunion and Mayotte at 2.5 km resolution. Short-term forecasts refreshed four times daily.",
  "common.forecastModelDescription_NAM_CONUS": "NOAA's North American Mesoscale model nest over the continental United States at 5 km resolution. Short-range forecasts refreshed four times daily.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "NOAA's North American Mesoscale model covering all of North America at 32 km resolution. Refreshed four times daily.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "SmartMixin's flagship forecast. For every hour at your location, we pick the best model available — typically a high-resolution regional model where one exists (AROME in France, ICON-D2 in Germany, HRRR in the United States, ARPEGE Europe across the continent…) and fall back to a global model elsewhere — then fill any gaps from neighbouring sources. The result is a single, seamless forecast covering anywhere in the world out to 14 days, refreshed automatically whenever any of the underlying models is updated.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Weatherflow's proprietary global forecast that blends multiple numerical weather models with observations from its Tempest weather station network. 10-day worldwide horizon.",
  "common.forecastModelDetailTitle": "Forecast model",
  "common.forecastModelScopeGlobal": "Global",
  "common.forecastModelScopeGlobalDescription": "This model covers the entire planet.",
  "common.forecastModelScopeRegional": "Regional",
  "common.forecastModelScopeRegionalDescription": "This model only covers a specific region.",
  "common.forecastModelSpecifications": "Specifications",
  "common.forecastSources": "Forecast sources",
  "common.freeAccount": "Free account",
  "common.freeSubscription": "Free premium subscription",
  "common.freeTrialForPeriod": "Free trial for {period} days",
  "common.frequency": "Frequency",
  "common.full": "Full",
  "common.fullscreen": "Fullscreen",
  "common.getStartedFree": "Get Started Free",
  "common.getUnlimitedAccess": "Get unlimited access to:",
  "common.good": "Good",
  "common.hail": "Hail",
  "common.help": "Help",
  "common.helpCategoryAccount": "Account",
  "common.helpCategoryBilling": "Billing",
  "common.helpCategoryGettingStarted": "Getting Started",
  "common.helpCategoryProviders": "Providers",
  "common.helpCategoryStations": "Stations",
  "common.helpCategoryTroubleshooting": "Troubleshooting",
  "common.helpCenter": "Help Center",
  "common.helpCenterDescription": "Find answers to common questions and learn how to get the most out of SmartMixin.",
  "common.hg": "Frost guard",
  "common.hidden": "Hidden",
  "common.hiddenSensors": "Hidden sensors",
  "common.hiddenStations": "Hidden stations",
  "common.hiddenStationsDescription": "You can unhide a station by tapping the eye icon next to it.",
  "common.high": "High",
  "common.home": "Home",
  "common.homeConnectService": "Own a weather station? Connect your service",
  "common.homeInformation": "Home information",
  "common.homeIntroduction": "Start connecting your external accounts to enjoy SmartMixin features.",
  "common.homeName": "Home name",
  "common.homeSubtitle": "Your weather, all in one place",
  "common.horizon": "Horizon",
  "common.horizonValue": "up to {value} hours",
  "common.iDontKnowYet": "I don't know yet",
  "common.indoor": "Indoor",
  "common.lastRainEvent": "Last rain event",
  "common.lastUpdate": "Last update",
  "common.legendHeavy": "Heavy",
  "common.legendLight": "Light",
  "common.legendLightningHelp": "Colour shows each strike's age over the last {minutes} minutes — most recent in white, oldest in dark red.",
  "common.legendNewest": "Newest",
  "common.legendOldest": "Oldest",
  "common.legendStationsHelp": "Marker colour reflects the value of the selected metric.",
  "common.lightningDataAttribution": "Lightning data: Blitzortung.org",
  "common.lightningStrikes": "Lightning strikes",
  "common.lightningStrikesDescription": "Display real-time lightning strikes on the map",
  "common.linkToSection": "Link to this section",
  "common.loading": "Loading",
  "common.location": "Location",
  "common.locationAddedToFavorites": "Location added to favorites",
  "common.locationNotGranted": "Location permission is not granted. Please allow access to your location in device settings.",
  "common.locationRemovedFromFavorites": "Location removed from favorites",
  "common.locations": "Locations",
  "common.low": "Low",
  "common.manage": "Manage",
  "common.manageAccount": "Manage account",
  "common.manageMySubscription": "Manage my subscription",
  "common.manageSensors": "Manage sensors",
  "common.manageSensorsDescription": "Drag items to reorder sensors. Tap the eye icon to show or hide sensors. Tap a name to rename it.",
  "common.manualBoost": "Manual boost",
  "common.manualSetpointUntil": "Manual setpoint until",
  "common.mapLayers": "Map layers",
  "common.mapLegend": "Map legend",
  "common.maxFavoriteLocationsReached": "You can only have up to 5 favorite locations. Remove one to add another.",
  "common.maximum": "Maximum",
  "common.measureToDisplay": "Measure to display",
  "common.medium": "Medium",
  "common.meshSize": "Grid size",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} min read",
  "common.modifyFavoriteStations": "Modify favorite stations",
  "common.modifyFavoriteStationsDescription": "You can reorder your favorite stations by dragging them. You can also remove them from the list.",
  "common.moduleType": "Module type",
  "common.monthTotal": "Month total",
  "common.more": "More",
  "common.moreInformation": "More information",
  "common.myLocation": "My location",
  "common.nearbyWeatherStations": "Nearby weather stations",
  "common.next": "Next",
  "common.nextHours": "Next hours",
  "common.no": "No",
  "common.noAccountNeeded": "No account needed",
  "common.noDataForThisPeriod": "No data for this period",
  "common.noLocationsFound": "No locations found",
  "common.noNetatmoWeatherStationYet": "You don't have a Netatmo weather station yet.",
  "common.noOutdoorModule": "There is no functional outdoor module for this station.",
  "common.noSearchResults": "No articles match your search",
  "common.noStationsFound": "No Stations Found",
  "common.noThermostatYet": "You dont' have a thermostat yet.",
  "common.notNow": "Not Now",
  "common.notPurchasedYet": "It seems this has not been purchased yet.",
  "common.noWeatherStation": "No weather station",
  "common.noWeatherStationYet": "You don't have a weather station yet.",
  "common.numberOfActiveWarnings": "{warning_count} active weather warnings",
  "common.onThisPage": "On this page",
  "common.openSettings": "Open Settings",
  "common.orChooseMonthly": "Or choose monthly:",
  "common.outdatedModule": "The data for this module is out of date.",
  "common.outdoor": "Outdoor",
  "common.outdoorTemperature": "Outdoor temperature",
  "common.pageNotFound": "Page Not Found",
  "common.pageNotFoundDescription": "The page you're looking for doesn't exist or has been moved.",
  "common.passwordUpdated": "Password successfully updated.",
  "common.personalWeatherIntelligence": "Your Personal Weather Intelligence",
  "common.platformMobileApp": "Mobile app",
  "common.platformMobileOnly": "Mobile app only",
  "common.platformWebApp": "Web app",
  "common.platformWebOnly": "Web app only",
  "common.popularArticles": "Popular articles",
  "common.premiumAccount": "Premium account",
  "common.premiumDescription": "Premium subscription unlocks many additional features such as advanced weather analysis, chart comparisons, regional forecast models and lots more.",
  "common.premiumFeatureAlerts": "Weather Alerts",
  "common.premiumFeatureAnalysis": "Advanced Weather Analysis",
  "common.premiumFeatureCharts": "Chart Comparisons",
  "common.premiumFeatureExport": "Data Export",
  "common.premiumFeatureForecast": "Regional Forecast Models",
  "common.premiumFeatureNotification": "Status Bar Widget",
  "common.premiumFeatureTitle": "Premium Feature",
  "common.premiumFeatureWidgets": "Home Screen Widgets",
  "common.pressureSummary": "Pressure summary",
  "common.previous": "Previous",
  "common.previousHours": "Previous hours",
  "common.profileUpdated": "Profile successfully updated.",
  "common.purchasedNetatmoPro": "You previously purchased Netatmo Pro ({date}). It gives you access to a subset of premium features. Subscribe to one of the following offers if you want to have access to all premium features.",
  "common.radarDataAttribution": "Radar data: RainViewer.com",
  "common.rain": "Rain",
  "common.rainEvents": "Rain events",
  "common.rainfallMeasurement": "Rainfall measurement",
  "common.rainRadar": "Rain radar",
  "common.rainRadarDescription": "Display rain radar overlay on the map",
  "common.rainSummary": "Rain summary",
  "common.range": "Range",
  "common.recentLocations": "Recent",
  "common.recentLocationsEmpty": "You recent history is empty.",
  "common.recentStations": "Recent stations",
  "common.relatedArticles": "Related Articles",
  "common.relay": "Relay",
  "common.removeFromFavorites": "Remove from favorites",
  "common.renameSensors": "Rename sensors",
  "common.resetZoom": "Reset Zoom",
  "common.restorePurchase": "Restore purchase",
  "common.room": "Room",
  "common.rooms": "Rooms",
  "common.savingsPercent": "Save {percent}%",
  "common.searchArticles": "Search articles...",
  "common.searchForALocation": "Search for a location...",
  "common.searchForLocation": "Search for a location",
  "common.searchForWeatherStation": "Search for a weather station",
  "common.searchResults": "Search results",
  "common.searchResultsEmpty": "No results found.",
  "common.searchResultsFound": "{count, plural, one {# result found} other {# results found}}",
  "common.searchStationsDescription": "Enter a city, address, or place name to find weather stations nearby.",
  "common.searchStationsHint": "Use the search bar above to discover weather stations in any location around the world.",
  "common.selectStationForComparison": "Select a station to compare with",
  "common.selectWeatherForecastProvider": "Please choose a weather provider",
  "common.serialNumber": "Serial number",
  "common.share": "Share",
  "common.shareOutdoorMeasures": "Share your outdoor measures",
  "common.shareOutdoorMeasuresDescription": "Participate in the SmartMixin community by making your outdoor measures visible to others. Indoor measures will never be shared.",
  "common.shareYourWeather": "Share your weather",
  "common.signalStrength": "Signal strength",
  "common.skip": "Skip",
  "common.smartThermostat": "Smart thermostat",
  "common.smartValve": "Smart valve",
  "common.snow": "Snow",
  "common.start": "Start",
  "common.startFreeTrial": "Start Free Trial",
  "common.startTime": "Start time",
  "common.station": "station",
  "common.stationAddedToFavorites": "Station added to favorites",
  "common.stationComparison": "Station comparison",
  "common.stationComparisonDescription": "Compare historical weather data with another station",
  "common.stationInformation": "Station information",
  "common.stationName": "Station name",
  "common.stationObservationsDescription": "Display the latest observations from weather stations",
  "common.stationRemovedFromFavorites": "Station removed from favorites",
  "common.stations": "stations",
  "common.stationsNear": "Stations near",
  "common.stationType": "Station type",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Stale",
  "common.statusSyncing": "Syncing",
  "common.stillNeedHelp": "Still need help?",
  "common.stillNeedHelpDescription": "If this article didn't answer your question, I'm happy to help you directly.",
  "common.subscribeNow": "Subscribe now - no trial",
  "common.sumOverThePeriod": "Cumulated over the period",
  "common.switchToPremium": "Switch to SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Temperature summary",
  "common.thankYouForFeedback": "Thank you for your feedback!",
  "common.thenPrice": "then {price}",
  "common.timeSelection": "Time selection",
  "common.timezone": "Timezone",
  "common.totalDuration": "Total duration",
  "common.tryAnotherLocation": "We couldn't find any weather stations near this location. Try searching for a different area.",
  "common.unknown": "Unknown",
  "common.untilChanged": "Until changed",
  "common.untilTime": "Until {time}",
  "common.updateAvailable": "Update available",
  "common.updateAvailableOpenAppStore": "Tap to open the App Store",
  "common.updateAvailableOpenGooglePlay": "Tap to open Google Play",
  "common.updateAvailableVersion": "Update available: v{version}",
  "common.upgrade": "Upgrade",
  "common.upgradeRequiredAndroid": "An upgrade of your application is required. Visit Google Play to upgrade.",
  "common.upgradeRequiredIos": "An upgrade of your application is required. Visit the App Store to upgrade.",
  "common.validate": "Validate",
  "common.validEmail": "A valid email address is required.",
  "common.very_low": "Very low",
  "common.visitNetatmoWebsite": "Visit Netatmo website",
  "common.wasArticleHelpful": "Was this article helpful?",
  "common.weatherCondition": "Weather condition",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain is an additional data source provided via the Tempest Weather System, powered by Nearcast Technology. NC Rain data is an estimate of the average rainfall accumulation around your Tempest at the neighborhood level",
  "common.weatherForecastModels": "Weather forecast models",
  "common.weatherIntelligencePlatform": "The Weather Intelligence Platform",
  "common.weatherMap": "Weathermap",
  "common.weatherMapMetaDescription": "SmartMixin provides interactive weather and radar maps for weather conditions for locations worldwide.",
  "common.weatherObservations": "Weather observations",
  "common.weatherStation": "Weather station",
  "common.weatherStations": "Weather stations",
  "common.welcome": "Welcome to SmartMixin!",
  "common.whenBackHome": "When will you be back home?",
  "common.wifiStrength": "WiFi strength",
  "common.wind": "Wind",
  "common.windMeasurement": "Wind measurement",
  "common.windSpeed": "Wind speed",
  "common.windSummary": "Wind summary",
  "common.yearToDate": "Year to Date",
  "common.yes": "Yes",
  "common.zoomImage": "Zoom image",
  "forecastMaps.addColor": "Add color",
  "forecastMaps.addLayer": "Add layer",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Back to maps",
  "forecastMaps.browseMaps": "Browse maps",
  "forecastMaps.build": "Build",
  "forecastMaps.buildCompleted": "Build completed",
  "forecastMaps.builderMetaDescription": "Compose custom forecast maps from weather model layers.",
  "forecastMaps.builderTitle": "Map builder",
  "forecastMaps.buildFailed": "The build failed. Please try again.",
  "forecastMaps.buildNotPossible": "This map cannot be built yet — no forecast data is available.",
  "forecastMaps.buildProgress": "Rendering… {completed}/{total} steps",
  "forecastMaps.buildStarting": "Starting build…",
  "forecastMaps.byModel": "By model",
  "forecastMaps.byZone": "By zone",
  "forecastMaps.colormap": "Colormap",
  "forecastMaps.colormapCustom": "Custom colors",
  "forecastMaps.colormapGroupDomain": "Weather presets",
  "forecastMaps.colormapGroupMatplotlib": "Scientific presets",
  "forecastMaps.colorScale": "Color scale",
  "forecastMaps.comingSoon": "This view is coming soon.",
  "forecastMaps.contourLevels": "Contour levels",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "France",
  "forecastMaps.countryGermany": "Germany",
  "forecastMaps.countryItaly": "Italy",
  "forecastMaps.countryScandinavia": "Scandinavia",
  "forecastMaps.countrySpain": "Spain",
  "forecastMaps.countrySwitzerland": "Switzerland",
  "forecastMaps.countryUnitedStates": "United States",
  "forecastMaps.customColormapMinColors": "A custom colormap needs at least two colors",
  "forecastMaps.customExtent": "Custom extent",
  "forecastMaps.deleteMap": "Delete map",
  "forecastMaps.deleteMapBody": "“{name}” and its rendered runs will be permanently deleted.",
  "forecastMaps.deleteMapTitle": "Delete this map?",
  "forecastMaps.displayName": "Display name",
  "forecastMaps.downloadMp4": "Download MP4",
  "forecastMaps.downscaling": "Barb thinning factor",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Draw area",
  "forecastMaps.east": "East",
  "forecastMaps.editMap": "Edit map",
  "forecastMaps.exportBuilding": "Preparing video…",
  "forecastMaps.exportError": "The video export failed. Please try again.",
  "forecastMaps.exportMp4": "Export MP4",
  "forecastMaps.exportNotReady": "The video is not ready yet. Please try again later.",
  "forecastMaps.extentDrawHint": "Drag on the map to draw the area",
  "forecastMaps.extentInvalid": "West must be less than east and south less than north",
  "forecastMaps.extentPanZoomHint": "Pan and zoom until the area fills the frame",
  "forecastMaps.flipbookView": "Animation",
  "forecastMaps.forecastModel": "Forecast model",
  "forecastMaps.forkAndEdit": "Fork & edit",
  "forecastMaps.height": "Height (inches)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Invalid color — use #RRGGBB",
  "forecastMaps.layers": "Layers",
  "forecastMaps.layerTypeBarbs": "Wind barbs",
  "forecastMaps.layerTypeContour": "Contour lines",
  "forecastMaps.layerTypeFilledContour": "Filled contours",
  "forecastMaps.layerTypeMagnitude": "Magnitude",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vector field",
  "forecastMaps.leave": "Leave",
  "forecastMaps.levelsCount": "Count",
  "forecastMaps.levelsInvalid": "Invalid contour levels",
  "forecastMaps.levelsModeArange": "Fixed step",
  "forecastMaps.levelsModeExplicit": "Explicit values",
  "forecastMaps.levelsModeLinspace": "Evenly spaced (count)",
  "forecastMaps.levelsStep": "Step",
  "forecastMaps.levelsValues": "Values",
  "forecastMaps.levelsValuesHint": "Comma-separated, ascending",
  "forecastMaps.localTimeHint": "Shown in your local time",
  "forecastMaps.map": "Map",
  "forecastMaps.mapDescription": "Description",
  "forecastMaps.mapName": "Map name",
  "forecastMaps.mapNameRequired": "Enter a name",
  "forecastMaps.mapSettings": "Map settings",
  "forecastMaps.mapView": "Interactive map",
  "forecastMaps.maxLayersReached": "This map has reached the maximum of {max} layers.",
  "forecastMaps.maxValue": "Max value",
  "forecastMaps.memoryBudgetExceeded": "The resolution exceeds the render budget — reduce DPI or height",
  "forecastMaps.memoryBudgetUsage": "Render budget: {percent}%",
  "forecastMaps.metaDescription": "Animated forecast maps rendered from weather model runs.",
  "forecastMaps.metric": "Metric",
  "forecastMaps.metricRequired": "Select a metric",
  "forecastMaps.metricUnavailable": "Not available for this model",
  "forecastMaps.minBelowMax": "Min must be less than max",
  "forecastMaps.minMaxRequired": "Min and max values are required for this layer type",
  "forecastMaps.minValue": "Min value",
  "forecastMaps.modelNoRun": "No completed run yet",
  "forecastMaps.moveLayerDown": "Move down",
  "forecastMaps.moveLayerUp": "Move up",
  "forecastMaps.myMaps": "My maps",
  "forecastMaps.nanClipToMin": "Clip to min",
  "forecastMaps.nanMask": "Mask",
  "forecastMaps.nanPolicy": "Missing data",
  "forecastMaps.nanSkip": "Skip",
  "forecastMaps.newMap": "New map",
  "forecastMaps.noCompletedRun": "This map has not been rendered yet. Please check back soon.",
  "forecastMaps.noLayers": "No layers yet. Add a layer to get started.",
  "forecastMaps.noMapsAvailable": "No forecast maps are available yet.",
  "forecastMaps.north": "North",
  "forecastMaps.opacity": "Opacity",
  "forecastMaps.overlayLegend": "Legend",
  "forecastMaps.pause": "Pause",
  "forecastMaps.play": "Play",
  "forecastMaps.pointValueError": "Could not load the forecast for this point.",
  "forecastMaps.pointValueLoading": "Loading forecast…",
  "forecastMaps.pointValueUnavailable": "No data for this time.",
  "forecastMaps.presets": "Presets",
  "forecastMaps.preview": "Preview",
  "forecastMaps.previewEmptyHint": "Configure at least one valid layer to render a preview.",
  "forecastMaps.previewFailed": "The preview failed",
  "forecastMaps.previewHour": "Forecast hour",
  "forecastMaps.previewRendering": "Rendering preview…",
  "forecastMaps.projection": "Projection",
  "forecastMaps.projectionLambertConformal": "Lambert conformal",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereographic",
  "forecastMaps.regionEurope": "Europe",
  "forecastMaps.regionNorthAmerica": "North America",
  "forecastMaps.removeColor": "Remove color",
  "forecastMaps.removeLayer": "Remove layer",
  "forecastMaps.retry": "Retry",
  "forecastMaps.run": "Run: {run}",
  "forecastMaps.save": "Save",
  "forecastMaps.selectExtentOnMap": "Select area on map",
  "forecastMaps.south": "South",
  "forecastMaps.title": "Forecast maps",
  "forecastMaps.uMetric": "U component",
  "forecastMaps.unitConversion": "Unit conversion",
  "forecastMaps.unitNone": "None",
  "forecastMaps.unsavedChangesBody": "You have unsaved changes. Leave and discard them?",
  "forecastMaps.unsavedChangesTitle": "Unsaved changes",
  "forecastMaps.useCurrentView": "Use current view",
  "forecastMaps.useModelDomain": "Off: the full model domain is used",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U and V metrics must differ",
  "forecastMaps.validTime": "Valid at {time}",
  "forecastMaps.valueBetween": "Must be between {min} and {max}",
  "forecastMaps.variable": "Variable",
  "forecastMaps.viewMap": "View map",
  "forecastMaps.vMetric": "V component",
  "forecastMaps.west": "West",
  "forecastMaps.windAnimation": "Wind animation",
  "intro.locationDescription": "Enable location access to get accurate weather predictions tailored to your exact area — no more one-size-fits-all forecasts.",
  "intro.locationTitle": "Forecasts Made for You",
  "intro.notificationDescription": "Turn on notifications to get timely alerts about weather changes that matter to you — rain, snow, or severe conditions, right when you need to know.",
  "intro.notificationsTitle": "Never Miss a Weather Shift",
  "intro.readyDescription": "Enjoy precise forecasts, real-time weather insights, and station data from around the globe — all in one powerful app.",
  "intro.readyTitle": "You're All Set!",
  "intro.welcomeDescription": "Get hyperlocal forecasts powered by top weather agencies — plus access to 40,000+ weather stations worldwide to see real-world conditions, past and present.",
  "intro.welcomeTitle": "Your Weather, Reimagined",
  "landing.alerts": "Alerts",
  "landing.alertsDescription": "Create your own alerts and get notified as soon as they are triggered.",
  "landing.featureAlertsDescription": "Set custom thresholds for any metric. Get notified when temperature drops, rain starts, or wind picks up.",
  "landing.featureAlertsTitle": "Smart Alerts",
  "landing.featureAnalyticsDescription": "Interactive charts, trend analysis, and detailed statistics. Dive deep into temperature, humidity, pressure, rain, and wind data.",
  "landing.featureAnalyticsTitle": "Advanced Analytics",
  "landing.featureExportDescription": "Download your weather data as CSV files for further analysis in Excel, Google Sheets, or your favorite tools.",
  "landing.featureExportTitle": "Export Your Data",
  "landing.featureForecastDescription": "Access 10+ professional forecast models including ECMWF, GFS, and regional models. Compare them side-by-side to make your own predictions.",
  "landing.featureForecastTitle": "Compare Forecast Models",
  "landing.featureHistoryDescription": "Access historical data with hourly, daily, and monthly scales. Export to CSV for research or personal archives.",
  "landing.featureHistoryTitle": "Rich History",
  "landing.featureMultiBrandDescription": "Connect Netatmo, Davis, Tempest, Ecowitt, Ambient Weather, and more. No more switching between apps.",
  "landing.featureMultiBrandTitle": "All Brands, One App",
  "landing.featuresSubtitle": "SmartMixin gives you the tools to analyze, compare, and understand your weather data like a pro.",
  "landing.featuresTitle": "Built for data lovers",
  "landing.finalCtaButton": "Create Free Account",
  "landing.finalCtaSubtitle": "Join thousands of weather enthusiasts who trust SmartMixin.",
  "landing.finalCtaTitle": "Ready to dive deeper into your weather data?",
  "landing.forecastDescription": "Access some of the best weather forecast models and compare them to get your own idea of what the weather will be.",
  "landing.forecasts": "Forecasts",
  "landing.heroCta": "Start Free",
  "landing.heroDescription": "Deep analytics, beautiful charts, and professional forecasts — all your weather stations unified in one powerful app.",
  "landing.heroSecondaryCta": "Explore the Map",
  "landing.heroTagline": "For Weather Enthusiasts",
  "landing.heroTitle": "See your weather like never before",
  "landing.pricingFeatureAdvancedMetrics": "Advanced metrics",
  "landing.pricingFeatureAlerts": "Custom alerts",
  "landing.pricingFeatureExport": "Data export (CSV)",
  "landing.pricingFeatureForecastComparison": "Forecast comparison",
  "landing.pricingFeatureForecasts": "Forecast models",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "10+ models",
  "landing.pricingFeatureReports": "Analysis & reports",
  "landing.pricingFeatureStationComparison": "Station comparison",
  "landing.pricingFeatureWidgets": "Home screen widgets",
  "landing.pricingFeatureYearOverYear": "Year-over-year analysis",
  "landing.pricingFree": "Free",
  "landing.pricingFreeCta": "Get Started",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Most Popular",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Get Started",
  "landing.pricingPremiumDescription": "From 1.99 €/month — subscribe on web, App Store, or Google Play",
  "landing.pricingSubtitle": "Start free, upgrade when you need more power.",
  "landing.pricingTitle": "Simple, transparent pricing",
  "landing.smartMixinDescription": "SmartMixin is an application that provides access to your weather station and 40K+ other stations worldwide. It helps you see and understand weather data.",
  "landing.statBrands": "Brands supported",
  "landing.statForecasts": "Forecast models",
  "landing.statStations": "Weather stations",
  "landing.supportedDevices": "Supported devices",
  "landing.supportedDevicesDescription": "On top of the stations from the World Meteorological Organization, SmartMixin supports a growing number of weather stations brands.",
  "landing.supportedDevicesNote": "Plus 40,000+ public stations from the World Meteorological Organization",
  "landing.supportedDevicesSubtitle": "Connect your existing weather station in minutes. We support 8 major brands and growing.",
  "landing.supportedDevicesTitle": "Works with your station",
  "landing.thermostatDescription": "Connect your Netatmo thermostat to correlate heating patterns with outdoor conditions.",
  "landing.thermostatManufacturers": "Thermostat manufacturers are also supported to correlate heating with outdoor conditions.",
  "landing.thermostatTitle": "Smart home integration",
  "landing.weatherAnalysis": "Weather Analysis",
  "landing.weatherAnalysisDescription": "SmartMixin comes with lots of data vizualization that lets you analyse weather data.",
  "landing.weatherAssistant": "Your weather assistant",
  "landing.weatherAssistantDescription": "Whether you are interested in current, historical or forecast weather conditions, SmartMixin provides with numerous insights whenever you need them.",
  "landing.weatherForecastModels": "Weather forecast models",
  "landing.weatherForecastModelsDescription": "SmartMixin provides access to the most accurate weather forecast models. You can easily compare their forecasts and make your own idea.",
  "landing.weatherMap": "Weather Map",
  "landing.weatherMapDescription": "Browse the map and vizualize what's the weather like anywhere around the globe.",
  "network.cancelError": "Request has been cancelled",
  "network.connectionError": "Server not available",
  "network.networkError": "Network not available",
  "network.serverError": "Something went wrong...",
  "network.timeoutError": "Connection timeout",
  "network.unknownError": "Unknown Error",
  "providerHints.ambientWeatherApiKey": "Created in your ambientweather.net account settings.",
  "providerHints.davisApiSecret": "Shown only once when you created the V2 API key — keep it safe.",
  "providerHints.davisV2ApiKey": "From your weatherlink.com V2 API keys page.",
  "providerHints.ecowittApi": "From your Ecowitt account API page.",
  "providerHints.ecowittApp": "The Application key, also from your Ecowitt account.",
  "providerHints.myAcuriteCredentialsBanner": "Use your My AcuRite account email and password — not your SmartMixin login.",
  "providerHints.myAcuriteEmail": "Your My AcuRite account email — not your SmartMixin login.",
  "providerHints.myAcuritePassword": "Your My AcuRite account password.",
  "providerHints.weatherflowToken": "Personal-use token from tempestwx.com → settings → data authorizations.",
  "providerHints.wundergroundEditKey": "Use a different key",
  "providerHints.wundergroundKey": "A long string from your Weather Underground member API keys page — not your wunderground.com password.",
  "providerHints.wundergroundKeyExample": "e.g. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API key verified",
  "providerHints.wundergroundKeyVerifying": "Checking key…",
  "providerHints.wundergroundNoStationsNearby": "No stations found near this location. Try entering a station ID directly.",
  "providerHints.wundergroundStationId": "Any Weather Underground station ID — yours, or a public station near you.",
  "providerHints.wundergroundStationIdExample": "e.g. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Get your Ambient Weather API key.",
  "providerIntro.davisStep2": "Get your Davis V2 API key and API secret.",
  "providerIntro.ecowittStep2": "Get your Ecowitt API key and Application key.",
  "providerIntro.getStarted": "Get started",
  "providerIntro.myAcuriteStep2": "Use your existing My AcuRite account email and password.",
  "providerIntro.netatmoEnergyStep2": "Sign in to Netatmo when prompted — no API key needed.",
  "providerIntro.netatmoWeatherStep2": "Sign in to Netatmo when prompted — no API key needed.",
  "providerIntro.signupBanner": "Almost there — create your free SmartMixin account to connect {provider}.",
  "providerIntro.step1": "Sign in to your SmartMixin account (NOT your {provider} login).",
  "providerIntro.step3EmailPassword": "Enter them here.",
  "providerIntro.step3KeyOrToken": "Paste it here.",
  "providerIntro.step3OAuth": "Authorize SmartMixin in the popup.",
  "providerIntro.step3Wunderground": "Paste your API key, then pick a nearby station or enter any station ID.",
  "providerIntro.title": "Connect {provider}",
  "providerIntro.weatherflowStep2": "Get your Tempest personal-use token.",
  "providerIntro.wundergroundBrowsePublic": "Don't have a station? Browse public ones",
  "providerIntro.wundergroundFindNearby": "Find stations near me",
  "providerIntro.wundergroundOrEnterId": "Or enter a station ID",
  "providerIntro.wundergroundStep2": "Get your Weather Underground API key. You'll then be able to connect any station — yours or a public one.",
  "reports.agroMeteorology": "Agrometeorology",
  "reports.analysis": "Analysis",
  "reports.annualCumulativeRainfallComparison": "Annual Cumulative Rainfall Comparison",
  "reports.annualHeatingDurationComparison": "Annual heating duration comparison",
  "reports.annualHeatingEfficiency": "Annual heating efficiency",
  "reports.annualIndoorComparison": "Annual Indoor Comparison",
  "reports.annualIndoorReport": "Annual Indoor Report",
  "reports.annualOutdoorComparison": "Annual Outdoor Comparison",
  "reports.annualOutdoorReport": "Annual Outdoor Report",
  "reports.annualReport": "Annual Report",
  "reports.annualSolarReport": "Annual solar report",
  "reports.annualWaterBalance": "Annual water balance",
  "reports.annualWaterBalanceCarryOver": "Carry over previous year",
  "reports.annualWaterBalanceDescription": "The water balance (simplified version, only Rain and evapotranspiration are used) helps manage water supply",
  "reports.avgHumidity": "Average humidity",
  "reports.avgMaxTemperature": "Average T°max",
  "reports.avgMetric": "Average {metric}",
  "reports.avgMinTemperature": "Average T°min",
  "reports.avgPressure": "Average Pressure",
  "reports.avgTemperature": "Average temperature",
  "reports.comfortable": "Comfortable (45% {lessThan} Humidity ≤ 60%)",
  "reports.cumulativeRainfall": "Cumulative rainfall",
  "reports.cumulativeRainfallDescription": "Track total rainfall accumulating over the selected period.",
  "reports.dailyMaxRainfall": "Daily Max. rainfall",
  "reports.dataExport": "Export data",
  "reports.dataExportXlsxFormatDescription": "Export all of your station's data in Excel format (*.xlsx). Once you click on the button, you will receive an email with the processed data after a few minutes.",
  "reports.daysWithFrost": "Days with frost",
  "reports.daysWithoutThaw": "Days without thaw",
  "reports.daysWithStrongFrost": "Days with strong frost",
  "reports.emailSent": "An email has been sent to your mailbox",
  "reports.grasslandTemperatureSum": "Grassland temperature sum",
  "reports.grasslandTemperatureSumDescription": "If the sum of {threshold} is exceeded in spring, the sustainable start of vegetation has been reached (works in Europe)",
  "reports.growingDegreeDays": "Growing degree days",
  "reports.highPressure": "Anticyclone (Average Pressure ≥ 1013mbar)",
  "reports.indoorReport": "Indoor Report",
  "reports.keyFacts": "Key Facts",
  "reports.longestRunOfRainyDays": "Longest run of rainy days",
  "reports.longestRunWithoutRun": "Longest run without rain",
  "reports.lowPressure": "Low Pressure (Average Pressure {lessThan} 1013mbar)",
  "reports.maxHumidity": "Maximum humidity",
  "reports.maxMetric": "Maximum {metric}",
  "reports.maxPressure": "Maximum Pressure",
  "reports.maxPressureMagnitude24h": "Maximum Magnitude (/24H)",
  "reports.maxTemperature": "Maximum temperature",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximum Magnitude (/24H)",
  "reports.minHumidity": "Minimum humidity",
  "reports.minMetric": "Minimum {metric}",
  "reports.minPressure": "Minimum Pressure",
  "reports.minPressureMagnitude24h": "Minimum Magnitude (/24H)",
  "reports.minTemperature": "Minimum temperature",
  "reports.minTempMagnitude24h": "Minimum Magnitude (/24H)",
  "reports.monthlyHeatingEfficiency": "Monthly heating efficiency",
  "reports.monthlyIndoorReport": "Monthly Indoor Report",
  "reports.monthlyOutdoorReport": "Monthly Outdoor Report",
  "reports.monthlyReport": "Monthly Report",
  "reports.monthlySolarReport": "Monthly solar report",
  "reports.monthlyWindReport": "Monthly Wind Report",
  "reports.numberOfDays": "Number of Days",
  "reports.outdoorReport": "Outdoor Report",
  "reports.rainfall": "Rainfall",
  "reports.rainyDays": "Rainy days",
  "reports.relativelyWet": "Relatively wet (60% {lessThan} Humidity ≤ 80%)",
  "reports.sendEmail": "Send email",
  "reports.tooDry": "Too dry (Humidity ≤ 45%)",
  "reports.tooWet": "Too wet (Humidity {greaterThan} 80%)",
  "reports.tropicalNights": "Tropical nights",
  "reports.waterBalance": "Water balance",
  "reports.yearToDateTemperature": "Year-to-date temperature",
  "reports.yearToDateTemperatureComparison": "Year-to-date temperature comparison",
  "sensors.aqiByChannel": "AQI by channel",
  "sensors.bgtSensors": "Black globe & WBGT",
  "sensors.cameraFeed": "Camera",
  "sensors.compareAqi": "Compare AQI",
  "sensors.compareHumidity": "Compare humidity",
  "sensors.compareMoisture": "Compare moisture",
  "sensors.comparePm25": "Compare PM2.5",
  "sensors.compareTemperatures": "Compare temperatures",
  "sensors.depthByChannel": "Depth by channel",
  "sensors.heatStressExtreme": "Extreme heat stress",
  "sensors.heatStressModerate": "Moderate heat stress",
  "sensors.heatStressNone": "No heat stress",
  "sensors.heatStressStrong": "Strong heat stress",
  "sensors.heatStressVeryStrong": "Very strong heat stress",
  "sensors.humidityByChannel": "Humidity by channel",
  "sensors.indoorAirQuality": "Indoor Air Quality",
  "sensors.indoorAirQualityPm": "PM2.5 & PM10 AQI",
  "sensors.indoorClimate": "Indoor climate",
  "sensors.indoorCo2Levels": "CO2 levels",
  "sensors.indoorTemperatureAndHumidity": "Temperature & humidity",
  "sensors.last24Hours": "24 hours",
  "sensors.last30Days": "30 days",
  "sensors.last7Days": "7 days",
  "sensors.leafTemperatureByChannel": "Leaf temperature by channel",
  "sensors.leafWetnessByChannel": "Leaf wetness by channel",
  "sensors.lightningSensor": "Lightning",
  "sensors.moistureByChannel": "Moisture by channel",
  "sensors.noDataAvailable": "No data available",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 by channel",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Select channel",
  "sensors.sensorDetailDescription": "View historical data and trends for your sensor channels.",
  "sensors.sensorHistory": "Sensor history",
  "sensors.soilConductivityByChannel": "Conductivity by channel",
  "sensors.soilTemperatureByChannel": "Soil temperature by channel",
  "sensors.strikesToday": "Strikes today",
  "sensors.temperatureByChannel": "Temperature by channel",
  "sensors.viewChart": "View chart",
  "settings.about": "About",
  "settings.aboutDescription": "License agreement, privacy policy",
  "settings.account": "Profile & Security",
  "settings.accountDescription": "Name, password, delete account",
  "settings.accountIntro": "Data concerns your account:",
  "settings.accountSection": "Account",
  "settings.appearance": "Appearance",
  "settings.appearanceDescription": "Theme and display options",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arabic",
  "settings.availableServices": "Available",
  "settings.bulgarian": "Bulgarian",
  "settings.cannotDisconnectLastAccount": "Cannot disconnect your only login method. Please add another login method first.",
  "settings.catalan": "Catalan",
  "settings.changeEmail": "Change email",
  "settings.changePassword": "Change password",
  "settings.chartGestures": "Gestures on charts",
  "settings.chartGesturesDescription": "Swiping on charts changes the time period, pinching charts changes time scale",
  "settings.connect": "Connect",
  "settings.connected": "Connected",
  "settings.connectedAccounts": "Connected Accounts",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Connected",
  "settings.connectedSince": "Connected since {date}",
  "settings.connectionSuccess": "{provider} account connected successfully",
  "settings.contactUs": "Contact Us",
  "settings.contactUsDescription": "Get help or send feedback",
  "settings.croatian": "Croatian",
  "settings.currentPassword": "Current password",
  "settings.czech": "Czech",
  "settings.danish": "Danish",
  "settings.dark": "Dark theme",
  "settings.dataDisplay": "Data display",
  "settings.dateAndTime": "Date and time",
  "settings.disconnect": "Disconnect",
  "settings.disconnectConfirmation": "Are you sure you want to disconnect your {provider} account?",
  "settings.disconnectionSuccess": "{provider} account disconnected successfully",
  "settings.donateButton": "Make a donation",
  "settings.donateDescription": "SmartMixin is built by a small team. If you find it useful, you can support its development with a one-time donation of any amount. It's a gift — it doesn't change your plan or unlock any features.",
  "settings.donateSuccessBody": "Your donation helps keep SmartMixin running and improving. We truly appreciate it.",
  "settings.donateSuccessTitle": "Thank you for your support!",
  "settings.donateTitle": "Support SmartMixin",
  "settings.dutch": "Dutch",
  "settings.emailChange": "Change email address",
  "settings.emailChangeConfirmation": "Email Change Confirmation",
  "settings.emailChangeFailure": "The email change link is invalid or has expired.",
  "settings.emailChangeSuccess": "Your email has been successfully changed to {newEmail}.",
  "settings.emailChangeVerificationSent": "A verification email has been sent to your new email address. Please check your inbox and click the link to confirm the change.",
  "settings.english": "English",
  "settings.forecastModelOrderEmpty": "No order saved — we use GFS by default.",
  "settings.forecastModelOrderFreeHint": "Premium models require a SmartMixin Premium subscription.",
  "settings.forecastModelOrderHelp": "We pick the first model in your list that covers each station.",
  "settings.forecastModelOrderReset": "Reset to default",
  "settings.forecastModelOrderTitle": "Default forecast model",
  "settings.forecastModels": "Forecast models",
  "settings.forecastModelsDescription": "Reorder by preference",
  "settings.french": "French",
  "settings.german": "German",
  "settings.gestures": "Gestures",
  "settings.greek": "Greek",
  "settings.helpCenter": "Help Center",
  "settings.helpCenterDescription": "FAQs and guides",
  "settings.hungarian": "Hungarian",
  "settings.integrationsSection": "Integrations",
  "settings.italian": "Italian",
  "settings.japanese": "Japanese",
  "settings.korean": "Korean",
  "settings.language": "Language",
  "settings.languageDescription": "Preferred language",
  "settings.light": "Light theme",
  "settings.newEmailAddress": "New email address",
  "settings.newPassword": "New password",
  "settings.newPasswordAgain": "New password again",
  "settings.norwegian": "Norwegian",
  "settings.notConnected": "Not connected",
  "settings.notificationsSection": "Notifications",
  "settings.oldPassword": "Old password",
  "settings.ongoingNotificationEnabled": "Enable ongoing notification",
  "settings.ongoingNotificationMetrics": "Displayed metrics",
  "settings.ongoingNotificationMetricsHint": "Drag to reorder selected metrics",
  "settings.ongoingNotificationPermissionRequired": "Notification permission is required",
  "settings.ongoingNotificationStation": "Weather station",
  "settings.passwordChange": "Password change",
  "settings.polish": "Polish",
  "settings.portuguese": "Portuguese",
  "settings.preferencesSection": "Preferences",
  "settings.premium": "SmartMixin Premium",
  "settings.premiumActive": "Active",
  "settings.premiumAnnualThenPrice": "Then 9.99 €/year",
  "settings.premiumAnnualTrialInfo": "Start with a {days}-day free trial",
  "settings.premiumCurrentPlan": "Current Plan",
  "settings.premiumDescription": "Manage your subscription",
  "settings.premiumDownloadApp": "Download the app to subscribe:",
  "settings.premiumExpiresOn": "Renews on {date}",
  "settings.premiumFreePlan": "Free",
  "settings.premiumInactive": "Not subscribed",
  "settings.premiumManageWebSubscription": "Manage your subscription, update payment method, or cancel.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Subscribe Annually",
  "settings.premiumSubscribedOn": "Subscribed on {platform}",
  "settings.premiumSubscribeMonthly": "Subscribe Monthly",
  "settings.premiumSubscribeOnWeb": "Subscribe now to unlock all premium features.",
  "settings.premiumSubscriptionSuccess": "Your subscription has been activated! Enjoy all premium features.",
  "settings.premiumSubscriptionSuccessTitle": "Welcome to Premium!",
  "settings.premiumWebappNotice": "Subscriptions can only be purchased through the SmartMixin mobile app on iOS or Android.",
  "settings.privacyPolicy": "Privacy policy",
  "settings.profile": "Profile",
  "settings.russian": "Russian",
  "settings.serbian": "Serbian",
  "settings.settings": "Settings",
  "settings.slovak": "Slovak",
  "settings.smallDecimals": "Small decimals",
  "settings.smallDecimalsDescription": "Display decimal digits in a smaller size",
  "settings.socialConnectionsIntro": "Link your social accounts to enable quick sign-in. You can connect or disconnect accounts at any time.",
  "settings.spanish": "Spanish",
  "settings.statusBarWidget": "Status Bar Widget",
  "settings.statusBarWidgetDescription": "Always-visible weather data",
  "settings.subscriptionSection": "Subscription",
  "settings.supportSection": "Support",
  "settings.swedish": "Swedish",
  "settings.systemTheme": "System theme",
  "settings.termsOfService": "Terms of service",
  "settings.turkish": "Turkish",
  "settings.ukrainian": "Ukrainian",
  "settings.units": "Units",
  "settings.unitsDescription": "Measurement units displayed within the application",
  "settings.update": "Update",
  "settings.updateYourProfile": "Update your profile",
  "settings.weatherServices": "Weather Services",
  "settings.weatherServicesConnected": "{count, plural, =0 {No services connected} one {# service connected} other {# services connected}}",
  "settings.weatherServicesDescription": "Connect Netatmo, Davis, Weatherflow, and more",
  "settings.windDirectionConvention": "Wind direction arrow",
  "settings.windDirectionConventionDescription": "Choose how wind direction arrows are displayed",
  "settings.windDirectionMeteorological": "Origin direction",
  "settings.windDirectionMeteorologicalDescription": "Arrow points where the wind comes from (meteorological convention)",
  "settings.windDirectionOceanographic": "Flow direction",
  "settings.windDirectionOceanographicDescription": "Arrow points where the wind blows to (oceanographic convention)",
  "units.absolutePressure": "Absolute pressure",
  "units.airDensity": "Air density",
  "units.airGap": "Air gap",
  "units.apparentTemperature": "Apparent temperature",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Avg.",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Black globe temp.",
  "units.boilerOn": "Boiler ON",
  "units.co2": "CO2",
  "units.conductivity": "Conductivity",
  "units.coolingDegreeDays": "Cooling degree days",
  "units.dailyHeatingDuration": "Daily heating duration",
  "units.dailyPrecipitation": "Daily precipitation",
  "units.dailyRain": "Daily rain",
  "units.degreeDay": "Degree day",
  "units.degreeDayShort": "DD",
  "units.depth": "Depth",
  "units.depthSensors": "Depth sensors",
  "units.dewPoint": "Dew point",
  "units.distance": "Distance",
  "units.downTrend": "down",
  "units.E": "E",
  "units.E_long": "East",
  "units.ENE": "ENE",
  "units.ENE_long": "East-Northeast",
  "units.ESE": "ESE",
  "units.ESE_long": "East-Southeast",
  "units.ET": "Evapotranspiration",
  "units.ETshort": "ET",
  "units.feelLike": "Feels-like",
  "units.feelsLike": "Feels like",
  "units.footMile": "Foot, mile",
  "units.frostPoint": "Frost point",
  "units.gust": "Gust",
  "units.heatIndex": "Heat index",
  "units.heatingDegreeDays": "Heating degree days",
  "units.heatingPower": "Heating power",
  "units.humidex": "Humidex",
  "units.humidity": "Humidity",
  "units.inch": "Inch",
  "units.inchOfMercury": "Inch of mercury",
  "units.kilometerPerHour": "Kilometers per hour",
  "units.knot": "Knot",
  "units.last12Hours": "Last 12 Hours",
  "units.last24Hours": "Last 24 Hours",
  "units.last3Hours": "Last 3 Hours",
  "units.last6Hours": "Last 6 Hours",
  "units.lastHour": "Last Hour",
  "units.lastLightningImpact": "Last impact",
  "units.lastMeasure": "Last measure",
  "units.leafSensors": "Leaf sensors",
  "units.leafWetness": "Leaf wetness",
  "units.lightningDistance": "Distance",
  "units.lightningStrikeCount": "Lightning strike count",
  "units.lightningStrikeDistance": "Lightning strike distance",
  "units.max": "Max.",
  "units.max_gust": "Max. gust",
  "units.max_wind": "Max. wind",
  "units.meterKilometer": "Meter, kilometer",
  "units.meterPerSecond": "Meters per second",
  "units.milePerHour": "Miles per hour",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter of mercury",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "North",
  "units.NE": "NE",
  "units.NE_long": "Northeast",
  "units.NNE": "NNE",
  "units.NNE_long": "North-Northeast",
  "units.NNW": "NNW",
  "units.NNW_long": "North-Northwest",
  "units.noise": "Noise",
  "units.normalizedHeatingCoefficient": "Normalized heating coefficient",
  "units.NW": "NW",
  "units.NW_long": "Northwest",
  "units.O3": "Ozone",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Precipitation",
  "units.pressure": "Pressure",
  "units.rain": "Rain",
  "units.rainRate": "Rain rate",
  "units.referenceTemperature": "Reference temperature",
  "units.relativePressure": "Relative pressure",
  "units.S": "S",
  "units.S_long": "South",
  "units.SE": "SE",
  "units.SE_long": "Southeast",
  "units.setPoint": "Setpoint",
  "units.snow": "Snow",
  "units.snowfall": "Snowfall",
  "units.soilMoisture": "Moisture",
  "units.soilSensors": "Soil sensors",
  "units.solarEnergy": "Solar energy",
  "units.solarRadiation": "Solar radiation",
  "units.speed": "Speed",
  "units.SSE": "SSE",
  "units.SSE_long": "South-Southeast",
  "units.SSW": "SSW",
  "units.SSW_long": "South-Southwest",
  "units.stableTrend": "stable",
  "units.sum": "Sum",
  "units.SW": "SW",
  "units.SW_long": "Southwest",
  "units.temperature": "Temperature",
  "units.temperatureAndHumiditySensors": "Temperature & humidity sensors",
  "units.temperatureSensors": "Temperature & humidity sensors",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Today",
  "units.upTrend": "up",
  "units.uv": "UV",
  "units.visibility": "Visibility",
  "units.W": "W",
  "units.W_long": "West",
  "units.wetBulbGlobeTemperature": "Wet bulb globe temp.",
  "units.wetBulbTemperature": "Wet bulb temp.",
  "units.wind": "Wind",
  "units.windChill": "Wind chill",
  "units.windDirection": "Wind direction",
  "units.windRun": "Wind run",
  "units.windRunDescription": "The wind run is the total distance of the traveled wind over a period of time",
  "units.WNW": "WNW",
  "units.WNW_long": "West-Northwest",
  "units.WSW": "WSW",
  "units.WSW_long": "West-Southwest"
}
